// extracted by mini-css-extract-plugin
module.exports = {"quoteSquiggle":"PressPage_quoteSquiggle__ZLKqX","headerSquiggle":"PressPage_headerSquiggle__2-mjI"};